import React, { useEffect, useState } from "react";
import { Box, Autocomplete, TextField } from "@mui/material";
import { useDataProvider, useNotify, useInput } from "react-admin";

export const SelectProviderInput = ({ source, label, alwaysOn }) => {
  const notify = useNotify();
  const dataProvider = useDataProvider();
  const [providers, setProviders] = useState([]);
  const {
    field: { value, onChange },
  } = useInput({ source }); // Conecta el input con react-admin

  useEffect(() => {
    dataProvider
      .getList("providers", {
        sort: { field: "name", order: "ASC" },
        filter: {},
      })
      .then(({ data }) => setProviders(data))
      .catch(() => {
        notify("Error cargando proveedores", { type: "error" });
      });
  }, [dataProvider, notify]);

  return (
    <Box sx={{ mb: 1 }}>
      <Autocomplete
        size="small"
        options={providers}
        getOptionLabel={(option) => option?.first_name || ""}
        value={providers.find((provider) => provider.id === value) || null}
        onChange={(event, newValue) => onChange(newValue ? newValue.id : "")}
        renderInput={(params) => <TextField {...params} label={label || "Proveedor"} variant="outlined" />}
        sx={{ width: 200 }}
      />
    </Box>
  );
};
